<template>
   <div class="generic-layout">
       <Header />
       <section class="py-5">
    <div class="container pt-5">
    
     <div class="steps-wrap">
        <div class="steps-tab-wrap-outer position-relative">
        <span class="position-absolute back-btn">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM20 7L1 7V9L20 9V7Z" fill="black"/>
            </svg>
            <span class="ps-2 fw-bold">Back</span>
        </span>
     <el-steps class="steps-tab-wrap pb-5" :active="active" finish-status="success">
      <el-step></el-step>
      <el-step></el-step>
      <el-step></el-step>
      <el-step></el-step>
     </el-steps>
    </div>

    <div class="step- pt-4">
      <div v-if="active === 0">
        <div class="ac-list-block border p-4 rounded-4 mb-5">
            <ul class="list-unstyled">
                <li class="d-flex mb-3">
                    <span><img src="img/price/orange-tick.svg" alt="" /></span>
                    <div class="ac-list-content ps-3">
                        <h6 class="fw-bold mb-1">Current Users</h6>
                        <p class="lh-sm">If you are a team member of a company that uses our service, please <a href="#" class="fw-bold">click here</a> to email our Support team, and they will add you to the system.</p>
                    </div>
                </li>
                <li class="d-flex mb-3">
                    <span><img src="img/price/orange-tick.svg" alt="" /></span>
                    <div class="ac-list-content ps-3">
                        <h6 class="fw-bold mb-1">New User</h6>
                        <p class="lh-sm">For an individual currently not working for a company we provide training to, click Individual User.</p>
                    </div>
                </li>
                <li class="d-flex mb-4">
                    <span><img src="img/price/orange-tick.svg" alt="" /></span>
                    <div class="ac-list-content ps-3">
                        <h6 class="fw-bold mb-1">New Company</h6>
                        <p class="lh-sm"> To sign up a company currently not using our service, select Company.</p>
                    </div>
                </li>
            </ul>
            <h6 class="fw-bold">Thank you for your business! 🎉</h6>
        </div>
        <div class="ac-selection-wrap mb-4">
            <h2 class="fw-bold text-center mb-5">Choose Your Account Type</h2>
            <div class="acc-type-wrap row">
                <div class="col">
                    <div class="ac-type-block border rounded-4 p-5 text-center position-relative">
                        <span class="active-tick"><img src="img/price/orange-tick.svg" alt=""></span>
                    <img src="img/price/individual.svg" alt="" />
                    
                    <h4 class="fw-bold">Individual</h4>
                    <span>New single user</span>
                </div>
                </div>
                <div class="col">
                    <div class="ac-type-block border rounded-4 p-5 text-center position-relative active">
                        <span class="active-tick"><img src="img/price/orange-tick.svg" alt=""></span>
                    <img src="img/price/company.svg" alt="" />
                    <h4 class="fw-bold">Company</h4>
                    <span>New Company signup</span>
                </div>
                </div>
            </div>
        </div>
        <div class="links-area text-center">
           <p class="mb-0">Already have an account?  <a href="#" class="fw-bold" >Login</a></p> 
           <p>Already work for a location and need to be added to the system? <a href="#" class="fw-bold">Click here</a></p> 
        </div>
      </div>
      <div v-if="active === 1">
        <div class="selected_user d-flex align-items-center mb-4">
            <span><img src="img/price/company.svg" alt="" /></span>
            <div class="select-user-con pl-3">
                <h5 class="fw-bold mb-0">Company</h5>
                <span>New company signup</span>
            </div>
        </div>
        <div class="ac-list-block border p-4 rounded-4 mb-5">
            <ul class="list-unstyled">
                <li class="d-flex mb-3">
                    <span><img src="img/price/orange-tick.svg" alt="" /></span>
                    <div class="ac-list-content ps-3">
                        <h6 class="fw-bold mb-1">Current Users</h6>
                        <p class="lh-sm">If you are a team member of a company that uses our service, please <a href="#" class="fw-bold">click here</a> to email our Support team, and they will add you to the system.</p>                    </div>
                </li>
                <li class="d-flex mb-3">
                    <span><img src="img/price/orange-tick.svg" alt="" /></span>
                    <div class="ac-list-content ps-3">
                        <h6 class="fw-bold mb-1">New User</h6>
                        <p class="lh-sm">For an individual currently not working for a company we provide training to, click Individual User.</p>
                    </div>
                </li>
                <li class="d-flex mb-4">
                    <span><img src="img/price/orange-tick.svg" alt="" /></span>
                    <div class="ac-list-content ps-3">
                        <h6 class="fw-bold mb-1">New Company</h6>
                        <p class="lh-sm"> To sign up a company currently not using our service, select Company.</p>
                    </div>
                </li>
            </ul>
            <h6 class="fw-bold">Thank you for your business! 🎉</h6>
        </div>
        <div class="form-list-block border p-4 rounded-4 mb-4">
        <form  class="general-form">
            <div class="row">
                <div class="col-md-6">
                  <label class="form-control-label fw-bold"
                    >First Name<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="First Name"
                    placeholder="Enter your first name"
                    rules="required"
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label fw-bold"
                    >Last Name<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="Last Name"
                    placeholder="Enter your Last Name"
                    rules="required"
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label fw-bold"
                    >Email Address<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="Email Address"
                    placeholder="Enter your email address"
                    rules="required"
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label fw-bold"
                    >Phone Number<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="Phone Number"
                    placeholder="Enter your phone number"
                    rules="required"
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label fw-bold"
                    >Company Name<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="Company Name"
                    placeholder="Enter your company name"
                    rules="required"
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label fw-bold"
                    >Estimated # of Users<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="Estimated # of Users"
                    placeholder="Enter your estimated user"
                    rules="required"
                  >
                  </base-input>
                </div>
                <div class="col-md-12">
                  <label class="form-control-label fw-bold"
                    ># of Locations<span class="requireField"> *</span></label
                  >
                  <base-input
                    type="text"
                    name="# of Locations"
                    placeholder="Enter your location"
                    rules="required"
                  >
                  </base-input>
                </div>

            </div>
            <!-- <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">First Name <span class="requireField">*</span></label>
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
                <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
            </div>
            <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label">Password</label>
            <input type="password" class="form-control" id="exampleInputPassword1">
            </div>
            <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">Check me out</label>
            </div> -->
            <base-button type="primary"  class="primary-orange border-0 w-100 py-2 rounded-3">Next</base-button>
        </form>
        </div>
        <div class="links-area text-left">
           <p class="mb-2">If you have any questions, please contact us at.</p> 
           <ul class="list-unstyled d-flex gap-4">
                <li>    
                    <span class="icon-img pe-2"><img src="img/price/sms.svg"></span>
                    <span class="icon-cont fw-bold text-decoration-underline">support@homeoftraining.com</span>
                </li>
                <li>    
                    <span class="icon-img pe-2"><img src="img/price/call.svg"></span>
                    <span class="icon-cont fw-bold text-decoration-underline">954-676-7900</span>
                </li>
           </ul> 
        </div>

      </div>
      <div v-if="active === 2">
        <h3>Step 3 Content</h3>
        <p>This is the content for Step 3.</p>
      </div>
      <div v-if="active === 3">
        <h3>Step 4 Content</h3>
        <p>This is the content for Step 4.</p>
      </div>
    </div>
</div>
    <div class="step-actions">
      <button :disabled="active === 0" @click="prevStep">Previous</button>
      <button :disabled="active === 4" @click="nextStep">Next</button>
    </div>
</div>
</section>
<Footer />


   </div>



  </template>
  <script>

import Header from '../Common/Header.vue';
import Footer from '../Common/Footer.vue';
import { Steps , Step } from "element-ui";

export default {
    name : "Account Type",
    data() {
    return {
        active: 0, // Index of the active step
    };
  },
  methods: {
    nextStep() {
      if (this.active < 4) {
        this.active++;
      }
    },
    prevStep() {
      if (this.active > 0) {
        this.active--;
      }
    },
  },
    components: {
    [Steps.name]: Steps,
    [Step.name]: Step,
    
    Header,
    Footer,
  }
}

  
  </script>
  <style scoped>
  .steps-tab-wrap >>> .el-step__icon.is-text {
    background: #EEECEB;
    width: 50px;
    height:50px;
    border:0;
    color:#C2C2C2;
    font-weight: 700;
    font-size: 24px;
  }
  .steps-tab-wrap >>> .is-process .el-step__icon.is-text , .steps-tab-wrap >>> .is-success .el-step__icon.is-text {
    background: linear-gradient(to right,  #e4973a 0%,#eb1a26 100%);
    color:white;
  }
  .steps-tab-wrap >>> .el-step.is-horizontal .el-step__line {
    top:25px;
  }
  .steps-tab-wrap >>> .el-step__head.is-success {
    border-color:#eb1a26;
  }
  </style>
  
  <!-- <style scoped>
:root {
    --prm-color: #0381ff;
    --prm-gray: #b1b1b1;
}
/*  unnecessary */
body {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  flex-direction:column;
}
section{
  width:100%;
}
/*  unnecessary finished*/

/* CSS */
.steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    position: relative;
}

.step-button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    background-color: var(--prm-gray);
    transition: .4s;
}

.step-button[aria-expanded="true"] {
    width: 60px;
    height: 60px;
    background-color: var(--prm-color);
    color: #fff;
}

.done {
    background-color: var(--prm-color);
    color: #fff;
}

.step-item {
    z-index: 10;
    text-align: center;
}

#progress {
  -webkit-appearance:none;
    position: absolute;
    width: 95%;
    z-index: 5;
    height: 10px;
    margin-left: 18px;
    margin-bottom: 18px;
}

/* to customize progress bar */
#progress::-webkit-progress-value {
    background-color: var(--prm-color);
    transition: .5s ease;
}

#progress::-webkit-progress-bar {
    background-color: var(--prm-gray);

}

a {
background-color: #ffff0047;
}
</style> -->


  